import React, { useEffect, useState } from "react";
import "../profileOrderDetail/style.scss";
import { useTranslation } from "react-i18next";
import PaymentMethodModal from "./paymentMethodModal";
import { order } from "../../services";
import {
  PAYMENT_METHOD_COD,
  PAYMENT_METHOD_MOMO,
  PAYMENT_METHOD_TRANSFER,
} from "../../common/constant";
import "./style.scss";

const RetryPayment = (props: any) => {
  const { order_id, kde_order_id, order_detail, fetchData } = props;
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState({
    payment_method: props.payment_method,
  });
  const [formSc, setFormSC] = useState("");

  useEffect(() => {
    if (formSc) {
      const frm: any = document.getElementById("s2bpay-bcollect-form");
      if (frm && frm.submit) {
        frm.submit();
      }
    }
  }, [formSc]);

  const handleOpen = () => {
    setIsVisible(true);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleRetryPayment = async (payment_method: any) => {
    await order.retryPaymentOrder(
      {
        order_id,
        kde_order_id,
        payment_method: payment_method?.payment_method,
      },
      async (data: any) => {
        if (!data) {
          setIsVisible(false);
          return;
        }

        switch (data.payment_method) {
          case PAYMENT_METHOD_MOMO:
            setFormSC(data.html);
            break;
          case PAYMENT_METHOD_COD:
          case PAYMENT_METHOD_TRANSFER:
            await fetchData(order_id);
            setIsVisible(false);
            break;

          default:
            break;
        }
      }
    );
  };

  return (
    <>
      <a className="order-button-retry-payment" onClick={handleOpen}>
        {/* <span className="sub-title">{t("btn_retry_payment")}</span> */}

        <span className="main-content">Thử lại</span>
        <img
          src="https://kdstore-testing.s3.ap-southeast-1.amazonaws.com/product_images/1624266353-iconRePayment-17.png"
          alt=""
        />
      </a>
      <PaymentMethodModal
        paymentMethod={paymentMethod}
        setPaymentMethod={setPaymentMethod}
        t={t}
        isVisible={isVisible}
        handleClose={handleClose}
        handleRetryPayment={handleRetryPayment}
        orderPrice={order_detail.order_price}
      />
      <div dangerouslySetInnerHTML={{ __html: formSc }}></div>
    </>
  );
};

export default RetryPayment;
